import React from "react";
import MessageContent from "./MessageContent";

const StartChatModal = ({ isOpen, onClose, activeChat, isLoading }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed z-[100] bottom-0 right-4 md:right-36 ">
      <div 
        className="bg-white border border-zinc-300 rounded-2xl overflow-hidden w-[92vw] max-w-[380px] md:w-[400px] lg:w-[420px] h-[98vh] md:h-[540px] lg:h-[620px] flex flex-col">     

        {isLoading ? (
          <div className="h-full flex items-center justify-center text-gray-500">
            Loading conversation...
          </div>
        ) : (
          <MessageContent
            activeChat={activeChat}
            isModal={true}
            onClose={onClose}
          />
        )}
      </div>
    </div>
  );
};

export default StartChatModal;